"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaterialType = void 0;
var MaterialType;
(function (MaterialType) {
    MaterialType["Concrete"] = "Concrete";
    MaterialType["Brick"] = "Brick";
    MaterialType["Asphalt"] = "Asphalt";
    MaterialType["Aluminium"] = "Aluminium";
    MaterialType["Vinyl"] = "Vinyl";
    MaterialType["Stucco"] = "Stucco";
    MaterialType["Fiberglass"] = "Fiberglass";
    MaterialType["Rubber"] = "Rubber";
    MaterialType["Wood"] = "Wood";
    MaterialType["Hardwood"] = "Hardwood";
    MaterialType["Softwood"] = "Softwood";
    MaterialType["Shingles"] = "Shingles";
    MaterialType["FiberglassShingles"] = "Fiberglass Shingles";
    MaterialType["Metal"] = "Metal";
    MaterialType["Clay"] = "Clay";
    MaterialType["Copper"] = "Copper";
    MaterialType["Elastomer"] = "Elastomer";
    MaterialType["Stone"] = "Stone";
    MaterialType["Drywall"] = "Drywall";
    MaterialType["CompositionShingles"] = "Composition Shingles";
    MaterialType["Ceramic"] = "Ceramic";
    MaterialType["PlasticSiding"] = "Plastic Siding";
    MaterialType["WoodSiding"] = "Wood Siding";
    MaterialType["Shake"] = "Shake";
    MaterialType["Carpet"] = "Carpet";
})(MaterialType = exports.MaterialType || (exports.MaterialType = {}));
